/* eslint-disable */
import React, { useEffect, useState, useContext } from "react";

import logout from "../../../assets/images/homepage/setting/security/securityLogout.svg";
import "./security.scss";
import SecurityTable from "./SecurityTable/index";
import HometabIcons from "constants/Homepage/icons";
import useTheme from "hooks/observer";
import SecurityPasswordChange from "components/SecurityPasswordChange/index";
import SecurityUpdatePassword from "components/SecurityUpdatePassword/index";
import TwoFactorQrCode from "components/TwoFactorQrCode/index";
import AuthenticationOtp from "components/AuthenticationModal/index";
import LogoutModal from "components/Models/LogoutModal/index";
import Modal from "components/Models/index";
import { ManageUser as MU } from "@induz/sdk";
import { useToast } from "components/Toaster/index";
import { signInContext } from "context/SigninContext";

function Security() {
  const theme = useTheme();
  const securityData = [
    {
      title: "Password",
      description: "",
      action: "Update Password",
      onClick: () => setVerifyPassword(true)
    },
    {
      title: "2-Step Verification",
      description:
        "Add an additional layer of security to your account during login.",
      action: "Update 2FA",
      onClick: () => setShow2FAConfirmation(true)
    },
    {
      title: "Manage your devices",
      description: "Keep your company account secure by managing devices.",
      action: "Logout All Devices"
    }
  ];
  const deviceData = [
    {
      id: 1,
      device: "Android Phone",
      os: "Android 12",
      lastUsed: "Today, 5 PM",
      location: "San Francisco"
    },
    {
      id: 2,
      device: "Work Desktop",
      os: "macOS 13.6",
      lastUsed: "Oct 27, 9 AM",
      location: "Manhattan"
    },
    {
      id: 3,
      device: "Personal Laptop",
      os: "Windows 11",
      lastUsed: "Oct 27, 9:30 PM",
      location: "Mumbai, India"
    }
  ];


  const columns = [
    { Header: "Device", accessor: "device" },
    { Header: "OS", accessor: "os" },
    { Header: "Last Used", accessor: "lastUsed" },
    { Header: "Location", accessor: "location" },
    {
      Header: "",
      accessor: "action",
      Cell: () => (
        <div className="button">
          <HometabIcons
            type="logout"
            color={theme !== "dark" ? "black" : "white"}
          />
        </div>
      )
    }
  ];
  const showToast = useToast();

  const [verifyPassword, setVerifyPassword] = useState(false);
  const [UpdatePassword, setUpdatePassword] = useState(false);
  const [show2FAConfirmation, setShow2FAConfirmation] = useState(false);
  const [verifyTwoFA, setverifyTwoFA] = useState(false);
  const [proceedTwoFA, setproceedTwoFA] = useState(false);
  const { userMail } = useContext(signInContext);

  // const updatePasswordHandler = async () => {
  //   setVerifyPassword(false);
  //   // setUpdatePassword(true);
  // };
  const verifyTwoFactorAuthenticationHandler = async () => {
    // api for update 2FA

    setUpdatePassword(false);
    setverifyTwoFA(false);
    setproceedTwoFA(false);

  };

  const proceedHandler = () => {
    setverifyTwoFA(false);
    setproceedTwoFA(true);
  };

  const verityAuthOtpHandler = async (otp) => {


    // await init();

    // const userInstance = new UserSettings(
    //   localStorage.getItem("mail"),
    //   localStorage.getItem("name"),
    //   localStorage.getItem("mobileNumber"),
    //   localStorage.getItem("address"),
    //   localStorage.getItem("profilePicture")
    // );

    // try {
    //   const faResponse = await userInstance.update_2fa(
    //     currentPassword.password,
    //     otp
    //   );
    //   console.log("response", faResponse);
    // } catch (error) {
    //   console.error("Failed to setup 2FA: ", error);
    // }
    const randomUser = await MU.getUserDetails(userMail);
    const val = await randomUser.verify("", otp);
    if (val) {
      showToast("2FA setup successfully", "success");
    } else {
      showToast("Invalid OTP", "error");
    }
    setproceedTwoFA(false);
    setCurrentPassword({ password: "", pin: "" });
  };
  const [showLogoutModal, setShowLogoutModal] = useState(false);

  // const [devicesList, setDevicesList] = useState([]);
  const [devicesList] = useState([]);
  const [currentPassword, setCurrentPassword] = useState({
    password: "",
    pin: ""
  });
  // const [originalPassword, setOriginalPassword] = useState("");
  // const [originalPassword] = useState("");

  // Fetch the current password from the API
  const getCurrentPassword = async () => {
    try {
      // await init();
      // const userInstance = new UserSettings(
      //   localStorage.getItem("mail"),
      //   localStorage.getItem("name"),
      //   localStorage.getItem("mobileNumber"),
      //   localStorage.getItem("address"),
      //   localStorage.getItem("profilePicture")
      // );

      // const currentPassword = await userInstance.get_cur_password();
      // console.log("Retrieved current password:", currentPassword);
      // setOriginalPassword(currentPassword);
    } catch (error) {
      console.error("Failed to retrieve current password:", error);
    }
  };

  const getDevicesList = async () => {
    try {
      // await init();
      // const wasmInstance = new IzWasm(URL);
      // const org = await wasmInstance.get_devices(
      //   localStorage.getItem("mail"),
      //   localStorage.getItem("name")
      // ); // (email,organization_name)

      // console.log(
      //   "devices",
      //   org,
      //   // org.get_applications(),
      //   // org.get_email(),
      //   // org.get_locations(),
      //   org.get_logged_devices(),
      //   "///"
      // );
      // if (org) {
      //   // const applications = [];
      //   const locations = JSON.parse(org.get_locations());
      //   const devices = JSON.parse(org.get_logged_devices());
      //   const osArr = JSON.parse(org.get_os());
      //   const lastUsed = JSON.parse(org.get_last_used());

      //   // Use map to create an array of objects
      //   const formattedData = devices.map((device, index) => ({
      //     device: device,
      //     os: osArr[index], // Change if OS data is available
      //     lastUsed: lastUsed[index],
      //     location: locations[index]
      //   }));
      //   setDevicesList(formattedData);
      // }
    } catch (error) {
      console.error("Error during get logged devices:", error);
    }
  };
  useEffect(() => {
    getDevicesList();
    getCurrentPassword();
  }, []);

  const logoutHandler = async () => {
    // await init();
    // const wasmInstance = new IzWasm(URL);
    // try {
    //   const logoutAllDevices = await wasmInstance.logout_all_devices(
    //     localStorage.getItem("mail")
    //   );
    //   console.log("logoutAllDevices response", logoutAllDevices);
    //   setShowLogoutModal(false);
    // } catch (error) {
    //   console.error("Failed to setup 2FA: ", error);
    // }
  };

  return (
    <div className="Security">
      {securityData.slice(0, 2).map((item, index) => (
        <div key={index} className="SecurityMain">
          <div
            className={`SecurityContent ${item.description === "" ? "nogap" : ""}`}
          >
            <h1>{item.title}</h1>
            <p>{item.description}</p>
          </div>
          <div className="SecurityAction">
            <p onClick={item.onClick} style={{ cursor: "pointer" }}>
              {item.action}
            </p>
          </div>
        </div>
      ))}

      {verifyPassword && (
        <SecurityUpdatePassword
          handlecancel={() => {
            setVerifyPassword(false);
            // To remove the password content field
            setCurrentPassword({ password: "", pin: "" });
          }}
          setVerifyPassword={setVerifyPassword}
          currentPassword={currentPassword}
          setCurrentPassword={setCurrentPassword}
        />
      )}
      {/* // flow change */}
      {UpdatePassword && (
        <SecurityPasswordChange
          handleCancelModel={() => {
            setUpdatePassword(false);
          }}
          handleSave={verifyTwoFactorAuthenticationHandler}
          pinRequired={false}
          title="2FA Verification"
          currentPassword={currentPassword}
          setCurrentPassword={setCurrentPassword}
        />
      )}
      {verifyTwoFA && (
        <TwoFactorQrCode
          handlecancel={() => setverifyTwoFA(false)}
          setVerifyPassword={setVerifyPassword}
          handleSave={proceedHandler}
        />
      )}
      {proceedTwoFA && (
        <AuthenticationOtp
          handlecancel={() => { setproceedTwoFA(false); showToast("2FA setup cancelled", "info"); }}
          handleSave={verityAuthOtpHandler}
          handleCancelModel={() => setproceedTwoFA(false)}
        />
      )}
      {show2FAConfirmation && (
        <Modal
          heading="Update Two Factor Authenticator"
          showFooter={true}
          showHeader={true}
          showCross={true}
          closable={true}
          handleCancel={() => setShow2FAConfirmation(false)}
          handleSave={() => {
            setShow2FAConfirmation(false);
            setverifyTwoFA(true);
          }}
          submitBtnText="Next"
          closeBtnTxt="Cancel"
          submitBtnColor="violet"
          closeBtnColor="white"
        >
          <div style={{ padding: "20px 0", textAlign: "center" }}>
            <p style={{
              color: "var(--text-grey-strong)",
              fontSize: "16px",
              lineHeight: "24px",
              margin: 0
            }}>
              TOTP URI/ QR code will be updated upon clicking immediately and old TOTP is no longer valid.
            </p>
          </div>
        </Modal>
      )}
      {showLogoutModal && (
        <LogoutModal
          title="Are you sure you want to Logout all the devices"
          setLogoutModal={setShowLogoutModal}
          logoutHandler={logoutHandler}
        />
      )}
      {/* <div className="SecurityWrapper">
        <div className="SecurityMain Main">
          <div className="SecurityContent">
            <h1>{securityData[2].title}</h1>
            <p>{securityData[2].description}</p>
          </div>
          <div
            className="SecurityAction"
            style={{ cursor: "pointer" }}
            onClick={() => setShowLogoutModal(true)}
          >
            <img src={logout} alt="logout" />
            <p>{securityData[2].action}</p>
          </div>
        </div>
        <div className="SecurityTable">
          <SecurityTable columns={columns} data={deviceData} />
          <SecurityTable columns={columns} data={devicesList} />
        </div>
      </div> */}
    </div>
  );
}

export default Security;
